import { request } from "../../Services/Api"
import { buildFormData, formDataHeaders } from "../../Utils/utils"

//export const getCredits = (params) => request.api.get(`/restful_api/alerts/list/filter`, params);
export const getCredits = (params) => request.api.get(`/payments/credit-requests/`, params)
export const getCreditsFilterOptions = (params) =>
  request.api.get("/payments/credit-requests/filter_options", params)
export const getCreditsOtherPage = (next) => request.api.get(next)
export const getCreditsStatistics = (params) =>
  request.api.get(`/payments/credit-requests/statistic/`, params)
export const getCreditsExport = ({ business_id, isAdmin, file_name, ...params }) => {
  if (isAdmin) {
    return request.api.get("/payments/credit-requests/export-credit-requests-admin/", params)
  } else {
    return request.api.get(`/payments/credit-requests/export-credit-requests/`, params)
  }
}
export const updateCredit = ({ id, ...newInfo }) => {
  if (newInfo?.status_type) {
    if (newInfo?.ids) {
      return request.api.put(`/payments/credit-requests/bulk-status-update/`, newInfo)
    } else {
      return request.api.put(`/payments/credit-requests/${id}/update-status/`, newInfo)
    }
  } else {
    return request.api.patch(`/payments/credit-requests/${id}/`, newInfo)
  }
}

export const pinCredit = ({ id, pin }) =>
  request.api.post(`/payments/credit-requests/${id}/${pin ? "pin" : "unpin"}/`)

export const deleteCredit = (id) => request.api.delete(`/payments/credit-requests/${id}/`)

export const getCreditDetails = (id) => request.api.get(`/payments/credit-requests/${id}/`)

export const attachProofCredit = ({ id, ...data }) => {
  const formData = buildFormData(data, "file_list")
  return request.api.post(`/payments/credit-requests/${id}/attachments/upload/`, formData, {
    headers: formDataHeaders
  })
}

export const resubmitCreditRequest = ({ id, data }) => {
  const formData = buildFormData(data, "file_list")
  return request.api.post(`/payments/credit-requests/${id}/resubmit/`, formData, {
    headers: formDataHeaders
  })
}

export const getCreditAutomation = () => request.api.get(`/payments/credit-automation/`)

export const requestCreditAutomation = () => request.api.post(`/payments/credit-automation/`)

export const confirmCreditAutomationAccess = (service_name) =>
  request.api.post(`/payments/credit-automation/confirm-access/`, { service_name })

export const turnOffCreditAutomation = () =>
  request.api.post(`/payments/credit-automation/turn-off/`)
